import { FC } from 'react';
import ReserveAreaDetail from './ReserveAreaDetail';
import UseReserveAreaDetail from './UseReserveAreaDetail';

const MinkaDetailContainer: FC = () => {
  return <ReserveAreaDetail {...UseReserveAreaDetail()} />;
};

export default MinkaDetailContainer;
